import { Controller } from "@hotwired/stimulus";

// Replaces the browser's own text for an empty required field with ours. The
// custom message has to be cleared again as soon as the user types, otherwise
// the field would stay invalid.
export default class extends Controller {
  static values = { text: String };

  show() {
    if (this.element.validity.valueMissing) this.element.setCustomValidity(this.textValue);
  }

  clear() {
    this.element.setCustomValidity("");
  }
}
